import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { forwardRef, ReactElement, Ref } from "react";
import styles from "./ButtonBase.module.less";

type NativeReactButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export type ButtonBaseProps = NativeReactButtonProps & { trackingId?: string; };

export const ButtonBase = forwardRef(
	(props: ButtonBaseProps, ref: Ref<HTMLButtonElement>): ReactElement => {
		const {
			trackingId,
			type = "button",
			className,
			children,
			...restOfTheProps
		} = props;

		return (
			<button
				{...restOfTheProps}
				{...setTrackingId(trackingId)}
				type={type}
				className={classNames(className, styles.root)}
				ref={ref}
			>
				{children}
			</button>
		);
	}
);
ButtonBase.displayName = "ButtonBase";